import { render, staticRenderFns } from "./SwipeImage2.vue?vue&type=template&id=56f0e2d0&scoped=true&"
import script from "./SwipeImage2.vue?vue&type=script&lang=js&"
export * from "./SwipeImage2.vue?vue&type=script&lang=js&"
import style0 from "./SwipeImage2.vue?vue&type=style&index=0&id=56f0e2d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f0e2d0",
  null
  
)

export default component.exports